import React from 'react';
import { Grid, Skeleton, styled, useTheme } from '@mui/material';

import { GraphDataPoint } from '../../interfaces/graphInterfaces';
import BoxGraphSection from './BoxGraphSection';

const classesPrefix = 'boxGraph';

const classes = {
    graphWrapper: `${classesPrefix}-graphWrapper`,
};

const StyledGrid = styled(Grid)(({ theme }) => {
    return {
        [`& .${classes.graphWrapper}`]: {
            display: 'flex',
            minHeight: theme.spacing(3),
        },
    };
});

const BoxGraph = ({
    loading,
    data,
}: {
    loading: boolean;
    data: GraphDataPoint[];
}): React.JSX.Element => {
    const theme = useTheme();

    const colors = theme.palette.dataVisualization[6];

    if (loading) {
        return (
            <Skeleton width='100%' height='35px' />
        );
    }

    return (
        <StyledGrid container direction='column' alignItems='stretch'>
            <Grid item xs={12} className={classes.graphWrapper}>
                {
                    data.map((graphDataItem, index) => {
                        return (
                            <BoxGraphSection
                                key={graphDataItem.name}
                                graphDataItem={graphDataItem}
                                color={colors[index]}
                            />
                        );
                    })
                }
            </Grid>
        </StyledGrid>
    );
};

export default BoxGraph;
